import queryString from 'query-string'
import { usingGet, usingPost } from '@ocean/api'
import { SeverityFilter } from 'modules/Notifications/types'

export const getUserNotifications = (severityFilter?: SeverityFilter[]) => {
  const queryParams = queryString.stringify({ severityFilter }, { skipNull: true })
  return usingGet(`Notifications/ListUserNotifications?${queryParams}`)
}

export const markUserNotificationsAsRead = (id: Guid) =>
  usingPost('Notifications/MarkUserNotificationsAsRead', { id })
